import {Wallpaper} from '../desktop/Wallpaper';
import {useDesktop} from '../desktop/DesktopContext';
import {AppSheet} from './AppSheet';
import {MobileDock} from './MobileDock';
import {MobileHome} from './MobileHome';
import {MobileStatusBar} from './MobileStatusBar';
import {useSheetHistory} from './useSheetHistory';

/**
 * The phone shell.
 *
 * It renders the SAME apps and the same state as the desktop shell — only the
 * chrome differs: a home screen instead of a dock with hover magnification, one
 * full-screen sheet instead of overlapping draggable windows, and a status bar
 * instead of a menu bar.
 */
export function MobileShell({title}: {title: string}) {
  const {activeWindowId, goHome, windows} = useDesktop();
  const active = windows.find((win) => win.id === activeWindowId) ?? null;

  useSheetHistory(active !== null, goHome);

  return (
    <div className="mobile-shell relative flex w-full flex-col overflow-hidden">
      <Wallpaper />
      <MobileStatusBar />
      <MobileHome title={title} />
      <MobileDock />
      {active ? <AppSheet key={active.id} state={active} /> : null}
    </div>
  );
}
